import type { PublishedAttribute } from 'flow/store/engine/types';


export const validationMessages = {
  attributeName: {
    required: 'Name is required.',
    uniqueName: 'A published attribute with this name already exists. Please enter a unique published attribute name.',
  },
};

export function isAttributeNameUnique(
  publishedAttributeProps: PublishedAttribute[],
  updatedAttributeName: string,
  originalAttributeName: string | null,
): boolean {
  const trimmedUpdatedName = updatedAttributeName.trim();
  if (!trimmedUpdatedName) return false;
  // If reverting to the original tag name, allow it
  if (
    originalAttributeName
      && trimmedUpdatedName.toLowerCase() === originalAttributeName.toLowerCase()
  ) {
    return true;
  }

  const filteredPublishedAttributes = publishedAttributeProps.filter(pa => {
    if (originalAttributeName && pa.attributeName === originalAttributeName) {
      return false;
    }
    return true;
  });
  const publishedAttributeNames = new Set(
    filteredPublishedAttributes.map(pa => pa.attributeName.toLowerCase()),
  );

  return Boolean(!publishedAttributeNames.has(trimmedUpdatedName.toLowerCase()));
}
